export const sharedBorderClasses = 'rounded-sm border border-input-enabled focus-within:border-input-activated focus-within:outline-0 hover:border-input-enabled-hover';

export const sharedInputClasses = `${sharedBorderClasses} w-full bg-input-enabled p-4`;

